import { render, staticRenderFns } from "./NewsDetails.vue?vue&type=template&id=8be0c82c"
import script from "./NewsDetails.vue?vue&type=script&lang=js"
export * from "./NewsDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports